class CmsBlockV2Model {
  constructor({
    block_id,
    name,
    identifier,
    enabled,
    content_type,
    file,
    block_content,
    params,
    block_content_css: css,
    block_content_js: js,
    component_name
  }) {
    this.id = block_id
    this.name = name
    this.identifier = identifier
    this.isEnabled = !!enabled
    this.contentType = content_type
    this.file = file
    this.blockContent = CmsBlockV2Model.parseBlockContent(block_content)
    this.params = params
    this.css = css
    this.js = js
    this.componentName = component_name
  }

  get isComponent() {
    return this.contentType === 'component'
  }

  static parseBlockContent(raw) {
    if (!raw) return {}
    try {
      return JSON.parse(raw)
    } catch {
      return {}
    }
  }
}

export default CmsBlockV2Model
